export default "__VITE_ASSET__4b0dc187__"